
//Россия	Рубль	RUB	Используется
// Узбекистан	Сум	UZS	НЕиспользуется
// Казахстан	Тенге	KZT	НЕиспользуется
// Турция	Лира	TRY	НЕиспользуется
// Кыргызстан	Сом	KGS (или KGN)	НЕиспользуется
// Евросоюз	Евро	EUR	НЕиспользуется
// США	Доллар США	USD	НЕиспользуется
// Азербайджан	Манат	AZN	НЕиспользуется
// Индия 	Рупия	INR	НЕиспользуется
// Пакистан 	Рупия	PKR	НЕиспользуется
// Бангладеш	така	BDT
export const currencyConfig = {
    USD: {
        symbol: '$',
        decimal: '.',
        thousand: ',',
        precision: 2,
        format: '%s%v'
    },
    EUR: {
        symbol: '€',
        decimal: ',',
        thousand: '.',
        precision: 2,
        format: '%v %s'
    },
    RUB: {
        symbol: '₽',
        decimal: ',',
        thousand: '.',
        precision: 2,
        format: '%v %s'
    },
    USDT: {
        symbol: 'USDT',
        decimal: '.',
        thousand: ',',
        precision: 2,
        format: '%v %s'
    },
    UZS: {
        symbol: 'so’m',
        decimal: ',',
        thousand: '.',
        precision: 2,
        format: '%v %s'
    },
    KZT: {
        symbol: '₸',
        decimal: ',',
        thousand: '.',
        precision: 2,
        format: '%v %s'
    },
    TRY: {
        symbol: '₺',
        decimal: ',',
        thousand: '.',
        precision: 2,
        format: '%v %s'
    },
    KGS: {
        symbol: 'сом',
        decimal: ',',
        thousand: '.',
        precision: 2,
        format: '%v %s'
    },
    AZN: {
        symbol: '₼',
        decimal: ',',
        thousand: '.',
        precision: 2,
        format: '%v %s'
    },
    INR: {
        symbol: '₹',
        decimal: '.',
        thousand: ',',
        precision: 2,
        format: '%s%v'
    },
    PKR: {
        symbol: '₨',
        decimal: '.',
        thousand: ',',
        precision: 2,
        format: '%s%v'
    },
    BDT: {
        symbol: '৳',
        decimal: '.',
        thousand: ',',
        precision: 2,
        format: '%s%v'
    }

};
export const coinConfig = {
    BTC: {
        symbol: '₿',
        decimal: '.',
        thousand: ',',
        precision: 6,
        format: '%s%v'
    },
    ETH: {
        symbol: 'Ξ',
        decimal: '.',
        thousand: ',',
        precision: 6,
        format: '%s%v'
    },
    USDT: {
        symbol: '$',
        decimal: '.',
        thousand: ',',
        precision: 6,
        format: '%s%v'
    },
    BNB: {
        symbol: '₿',
        decimal: '.',
        thousand: ',',
        precision: 6,
        format: '%s%v'
    },
    TON: {
        symbol: 'TON',
        decimal: '.',
        thousand: ',',
        precision: 6,
        format: '%s%v'
    }
};
